/// <reference types="@angular/localize" />

import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {
  enableProdMode,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {provideRouter} from '@angular/router';

import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {ThemeService} from 'ng2-charts';
import {AppComponent} from './app/app.component';
import {routes} from './app/app.routes';

import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    importProvidersFrom(
      BrowserModule,
    ),
    provideRouter(routes),
    provideAppInitializer(() => {
      return inject(KeycloakService).init({
        config: environment.auth,
        initOptions: {
          onLoad: 'check-sso',
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        },
        enableBearerInterceptor: true,
        loadUserProfileAtStartUp: true,
      }).catch(err => console.error('Keycloak init failed', err));
    }),
    importProvidersFrom(KeycloakAngularModule),
    provideHttpClient(withInterceptorsFromDi()),
    ThemeService,
  ],
})
  .catch(err => console.error(err));
